<template>
<!-- eslint-disable -->
  <v-navigation-drawer v-model="showDrawer" app temporary>
    <v-row no-gutters align="stretch" style="height: 100%">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12" class="pa-2">
            <v-img
              contain
              :src="require('@/assets/logo2.png')"
              transition="scale-transition"
            />
          </v-col>
          <v-col cols="12">
            <v-list dense>
              <v-list-item 
                :to="routeHome" 
                :exact="true" 
                active-class="primary darken-2" 
                exact-active-class="primary darken-2"
                style="border-top: 1px solid #6f6f6f70;border-bottom: 1px solid #6f6f6f70"
              >
                <v-list-item-icon>
                  <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>HOME</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                style="border-bottom: 1px solid #6f6f6f70"
              >
                <v-list-item-content>
                  <v-list-item-title>CATEGORIAS</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item 
                v-for="(categoria, i) in categorias" 
                :key="i" 
                :to="categoria.to" 
                :exact="true"
                active-class="primary darken-2" 
                exact-active-class="primary darken-2"
                class="pl-8"
                style="border-bottom: 1px solid #6f6f6f70"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ categoria.nombre }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters wrap justify="center" align-content="end" style="height: 100%">
          <v-spacer/>
           <v-col cols="12">
            <v-list>
              <v-list-item @click="clickCancelacion" style="border-top: 1px solid #6f6f6f70;border-bottom: 1px solid #6f6f6f70;">
                <span class="ml-2">{{ 'Cancelación' }}</span>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col v-if="loggedIn" cols="12">
            <v-list>
              <v-list-item @click="doLogout" style="border-top: 1px solid #6f6f6f70;border-bottom: 1px solid #6f6f6f70;">
                <v-icon>mdi-logout</v-icon>
                <span class="ml-2">{{ 'Cerrar sesión' }}</span>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12">
            <v-btn @click="clickTyc" text x-small style="text-transform: none">
              <span>Términos y condiciones</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      miniVariant: true,
      show: false
    }
  },
  computed: {
    ...mapGetters({
      getAllCategorias: 'viralmobile/getAllCategorias',
      loggedIn: 'login/loggedIn'
    }),
    showDrawer: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    routeHome() {
      return { name: 'home' }
    },
    categorias() {
      return this.getAllCategorias.map(x => {
        return {
          id: x.id,
          nombre: x.nombre.toUpperCase(),
          to: {
            name: 'category',
            params: {
              id: x.id
            }
          }
        }
      })
    }
  },
  methods: {
    ...mapActions({
      logout: 'login/logout'
    }),
    doLogout() {
      this.logout()
      this.$emit('input', false)
    },
    clickTyc() {
      this.$router.push({ name: 'tyc' })
    },
    clickCancelacion() {
      this.$router.push({ name: 'cancelacion' })
    }
  }
}
</script>
